function settings( google, imageDir ) {

  // Global map styling

  let styles = [{
    "featureType": "administrative",
    "elementType": "labels.text.fill",
    "stylers": [{
      "color": "#444444"
    }]
  }, {
    "featureType": "landscape",
    "elementType": "all",
    "stylers": [{
      "color": "#f2f2f2"
    }]
  }, {
    "featureType": "poi",
    "elementType": "all",
    "stylers": [{
      "visibility": "off"
    }]
  }, {
    "featureType": "road",
    "elementType": "all",
    "stylers": [{
      "saturation": -100
    }, {
      "lightness": 45
    }]
  }, {
    "featureType": "road.highway",
    "elementType": "all",
    "stylers": [{
      "visibility": "simplified"
    }]
  }, {
    "featureType": "road.arterial",
    "elementType": "labels.icon",
    "stylers": [{
      "visibility": "off"
    }]
  }, {
    "featureType": "transit",
    "elementType": "all",
    "stylers": [{
      "visibility": "off"
    }]
  }, {
    "featureType": "water",
    "elementType": "all",
    "stylers": [{
      "color": "#57687a"
    }, {
      "visibility": "on"
    }]
  }];

  // Map options for static map and find a home Map
  // Map markers - house and development

  return {

    houseMarker: {
      path           : "M0,0V21.866L8.594,30,17,21.866V0H0Z",
      fillColor      : '#e7304b',
      fillOpacity    : 1,
      anchor         : new google.maps.Point(9.5555, 30),
      strokeLinecap  : 'square',
      strokeLineJoin : 'miter',
      strokeWeight   : 1,
      strokeColor    : 'white', //'#c61d2f',
      scale          : 1.2
    },

    developmentMarker: {
      path         : google.maps.SymbolPath.CIRCLE,
      scale        : 12,
      fillColor    : 'rgba(140, 155, 60,  1.0)',
      fillOpacity  : 1,
      strokeWeight : 1,
      strokeColor  : 'white'
    },

    location: {
      formatted_address: "New Zealand",
      geometry: {
        location: new google.maps.LatLng(-36.8406, 174.7400)
      },
      nzCenter: {
        zoom: 6, //15,s
        center: new google.maps.LatLng(-41.195824, 174.763695) //(-36.8406, 174.7400)
      },
      northIslandCenter: {
        zoom: 9,
        center: new google.maps.LatLng(-36.780906, 174.719953) //(-37.87798, 175.83400)
      },
      southIslandCenter: {
        zoom: 11,
        center: new google.maps.LatLng(-43.531650, 172.639454) //(-43.58326, 170.60451)
      }
    },

    mapOptions: {
      zoom: 6, //15,s
      center: new google.maps.LatLng(-41.195824, 174.763695),
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      backgroundColor: 'none',
      scrollwheel: false,
      zoomControl: false,
      zoomControlOptions: {
        position: google.maps.ControlPosition.TOP_LEFT,
        style: google.maps.ZoomControlStyle.LARGE
      },
      mapTypeControl: true,
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
        position: google.maps.ControlPosition.LEFT_TOP,
        mapTypeIds: [
          google.maps.MapTypeId.ROADMAP,
          google.maps.MapTypeId.TERRAIN
        ]
      },
      streetViewControl: false,
      styles: styles
    },

    staticMapOptions: {
      zoom: 15,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      backgroundColor: 'none',
      scrollwheel: false,
      draggable: false,
      disableDefaultUI: true,
      styles: styles
    }
  };
}

export { settings as default };
